import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ElementRef, AfterViewInit } from '@angular/core';

@Component({
    selector: 'dropdown-button',
    templateUrl: './dropdown-button.component.html',
    styleUrls: ['./dropdown-button.component.scss'],
    standalone: false
})
export class DropdownButtonComponent implements OnInit, AfterViewInit {
  @Input() dropDownData : any
  @Input() disabled: boolean = false;
  @Output() selectPayment = new EventEmitter
  @ViewChild('selectElement', { static: false }) selectElement!: ElementRef;
  
  constructor() { }

  ngOnInit(): void {
  }
  
  ngAfterViewInit(): void {
    // Ensure dropdown can be focused on click
    if (this.selectElement && !this.disabled) {
      this.selectElement.nativeElement.addEventListener('click', (e: any) => {
        if (this.disabled) return;
        // Focus the select element to open dropdown on single click
        if (e.target.closest('.select') && document.activeElement !== this.selectElement.nativeElement) {
          e.preventDefault();
          e.stopPropagation();
          this.selectElement.nativeElement.focus();
        }
      });
    }
  }
  
  onClick(e: any) {
    if (this.disabled) return;
    
    // If clicking on an option (not the selected one), let the radio input handle it
    if (e.target.tagName === 'LABEL' && e.target.classList.contains('option')) {
      // Check if this is the selected option
      const input = e.target.previousElementSibling;
      if (input && input.checked) {
        // This is the selected option - focus to open dropdown
        if (this.selectElement && document.activeElement !== this.selectElement.nativeElement) {
          e.preventDefault();
          e.stopPropagation();
          this.selectElement.nativeElement.focus();
        }
      }
      // For non-selected options, let the default label behavior handle it (triggers radio change)
      return;
    }
    
    // For clicks on the select container itself, focus to open dropdown
    if (this.selectElement && e.target.classList.contains('select')) {
      if (document.activeElement !== this.selectElement.nativeElement) {
        e.preventDefault();
        e.stopPropagation();
        this.selectElement.nativeElement.focus();
      }
    }
  }
  
  onSelect(e){
    if (this.disabled) return;
    let val = e.target.value
    if(val) this.selectPayment.emit(val)
  }
}
